import { render } from "./SkillAssessmentBatchDialog.vue?vue&type=template&id=5093d7f0&scoped=true"
import script from "./SkillAssessmentBatchDialog.vue?vue&type=script&lang=js"
export * from "./SkillAssessmentBatchDialog.vue?vue&type=script&lang=js"

import "./SkillAssessmentBatchDialog.vue?vue&type=style&index=0&id=5093d7f0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5093d7f0"]])

export default __exports__